import React, { useEffect, useState } from "react";
import {
  FamilyHistorydata,
  LifestyleDeterminantsdata,
  Medicalhistoycategories,
  PsychiatricHistorydata,
  SurgicalHistorydata,
} from "../AgencyFlow/AgencyScreens/Patientinfoeditscreens/Historydata";
import {
  FamilyHistoryonsubmit,
  FamilyHistoryonsubmitUpdate,
  FetchFamilyHistory,
  FetchLifestyleDeterminants,
  FetchMedicalHistory,
  FetchPsychiatricHistory,
  GetSurgicalHistory,
  LifestyleDeterminantsnsubmit,
  LifestyleDeterminantsonsubmitUpdate,
  MedicalHistoryonsubmit,
  MedicalHistoryonsubmitUpdate,
  PsychiatricHistoryonsubmit,
  PsychiatricHistoryonsubmitUpdate,
  SurgicalHistoryonsubmit,
  SurgicalHistoryonsubmitUpdate,
} from "../../api/helper";
import { ShowToast } from "../../helpers/ToastService";

const MedicalHistory = ({ data, appointmentdetail ,onComplete}) => {
  const [openModal, setOpenModal] = useState(null);
  const [medicalhistoryget, setmedicalhistoryget] = useState(null);
  const [SurgicalHistoryget, setSurgicalHistoryget] = useState(null);
  const [familyhistoryget, setfamilyhistoryget] = useState(null);
  const [psychiatricdata, setpsychiatricdata] = useState(null);
  const [LifestyleDeterminantsget, setLifestyleDeterminantsget] =
    useState(null);
  const [LifestyleDeterminants, setLifestyleDeterminants] = useState({
    tobaccoUse: {
      currentEverydaySmoker: false,
      currentSomeDaySmoker: false,
      formerSmoker: false,
      heavyTobaccoSmoker: false,
      lightTobaccoSmoker: false,
      neverSmoker: false,
      smokerCurrentStatusUnknown: false,
      unknownIfEverSmoked: false,
    },
    alcoholUse: {
      doNotDrink: false,
      drinkDaily: false,
      frequentlyDrink: false,
      historyOfAlcoholism: false,
      occasionalDrink: false,
    },
    substanceUse: {
      ivdu: false,
      illicitDrugUse: false,
      noIllicitDrugUse: false,
      prescriptionDrugMisuse: false,
      marijuanaUse: false,
      cocaineUse: false,
      heroinUse: false,
      methamphetamineUse: false,
      hallucinogenUse: false,
      inhalantUse: false,
      stimulantUse: false,
      sedativeUse: false,
      opioidUse: false,
    },
    cardiovascularHealth: {
      eatHealthyMeals: false,
      regularExercise: false,
      takeDailyAspirin: false,
    },
    patternsHistorySubstanceUse: {
      polysubstanceUse: false,
      hxOfSubstanceRehab: false,
      hxOfWithdrawalSymptoms: false,
      affectingDailyLife: false,
      impactingRelationships: false,
      impactingEmployment: false,
      other: false,
    },
    safetyPractices: {
      householdSmokeDetector: false,
      keepFirearmsInHome: false,
      wearSeatbelts: false,
    },
    sexualActivity: {
      exposureToSTI: false,
      nonHeterosexualActivity: false,
      notSexuallyActive: false,
      safeSexPractices: false,
      sexuallyActive: false,
    },
    birthGender: {
      male: false,
      female: false,
      undifferentiated: false,
    },
  });
  const [psychiatricHistoryData, setPsychiatricHistoryData] = useState({
    psychiatricConditions: {
      anxietyDisorders: false,
      depression: false,
      bipolarDisorder: false,
      schizophrenia: false,
      obsessiveCompulsiveDisorder: false,
      postTraumaticStressDisorder: false,
      substanceUseDisorders: false,
      eatingDisorders: false,
      autismSpectrumDisorder: false,
      adhd: false,
      personalityDisorders: false,
    },
    neurocognitiveDisorders: {
      dementia: false,
      alzheimersDisease: false,
      mildCognitiveImpairment: false,
      parkinsonsDisease: false,
      huntingtonsDisease: false,
    },
    developmentalDisorders: {
      intellectualDisability: false,
      speechLanguageDisorders: false,
      learningDisorders: false,
      touretteSyndrome: false,
    },

    symptoms: {
      suicidalThoughts: false,
      selfHarm: false,
      hearingSeeingThings: false,
      delusions: false,
      anxietyOrPanicAttacks: false,
      moodSwings: false,
      paranoia: false,
      otherSymptoms: false,
    },
    mentalHealthTreatmentHistory: {
      hospitalizedForPsychiatricCondition: false,
      therapyForMentalHealthConcerns: false,
      prescribedPsychiatricMedications: false,
      historyOfElectroconvulsiveTherapy: false,
      otherTreatmentHistory: false,
    },
    substanceUse: {
      alcoholUse: false,
      marijuanaUse: false,
      illicitDrugUse: false,
      intravenousDrugUse: false,
      noSubstanceUse: false,
    },
    familypaychiaticHistory: {
      anxietyDisorders: false,
      depression: false,
      bipolarDisorder: false,
      schizophrenia: false,
      ptsd: false,
      substanceUseDisorders: false,
      otherfamilypaychiaticHistory: false,
    },
    socialEnvironmentalstressors: {
      financialProblems: false,
      rlationshipIssues: false,
      jobRelatedStress: false,
      familyConflicts: false,
      traumaPhysicalEmotionalSexual: false,
      othersocialEnvironmentalstressors: false,
    },
    cognitiveandBehavioralPatterns: {
      difficultyConcentration: false,
      decisionMakingProblems: false,
      problemSolvingChallenges: false,
      impulsiveBehaviors: false,
      othercognitiveandBehavioralPatterns: false,
    },
    sleepandEnergyLevels: {
      difficultyFallingAsleep: false,
      frequentWaking: false,
      oversleeping: false,
      chronicFatigue: false,
      lowEnergyLevels: false,
    },
  });
  const [formData, setFormData] = useState({
    generalHealthConditions: {
      noHealthConcern: false,
      arthritis: false,
      asthma: false,
      bleedingDisorder: false,
      cadUnder55: false,
      copd: false,
      diabetes: false,
    },
    cardiovascularAndOthers: {
      heartAttack: false,
      heartDisease: false,
      highCholesterol: false,
      hypertension: false,
      mentalIllness: false,
      osteoporosis: false,
      stroke: false,
    },
    cancer: {
      breastCA: false,
      colonCA: false,
      ovarianCA: false,
      prostateCA: false,
      uterineCA: false,
      otherCA: false,
    },
  });
  const [medicalData, setMedicalData] = useState({
    head: {
      trauma: false,
      migraines: false,
      concussion: false,
      skullFracture: false,
    },
    eyes: {
      blindness: false,
      cataracts: false,
      glaucoma: false,
      wearsGlassesContacts: false,
      eyeInfection: false,
    },
    ears: {
      hearingLoss: false,
      tinnitus: false,
      earInfections: false,
      hearingAids: false,
    },
    noseSinuses: {
      sinusInfection: false,
      allergicRhinitis: false,
      nasalFracture: false,
      nasalPolyps: false,
    },
    mouthThroatTeeth: {
      gumDisease: false,
      toothDecay: false,
      tonsillitis: false,
      dentures: false,
    },
    cardiovascular: {
      hypertension: false,
      angina: false,
      heartAttack: false,
      dysrhythmia: false,
    },
    respiratory: {
      asthma: false,
      copd: false,
      pneumonia: false,
      bronchitis: false,
    },
    neurological: {
      seizures: false,
      stroke: false,
      migraines: false,
      multipleSclerosis: false,
    },
    musculoskeletal: {
      arthritis: false,
      gout: false,
      fractures: false,
      muscleStrain: false,
    },
    skin: {
      psoriasis: false,
      eczema: false,
      dermatitis: false,
      skinCancer: false,
    },
    endocrine: {
      diabetesType1: false,
      diabetesType2: false,
      hypothyroidism: false,
      hyperthyroidism: false,
    },
    infectiousDiseases: {
      tuberculosis: false,
      hiv: false,
      hepatitisB: false,
      hepatitisC: false,
    },
    hematologicOncologic: {
      anemia: false,
      leukemia: false,
      lymphoma: false,
      clottingDisorders: false,
    },
    psychiatric: {
      anxiety: false,
      depression: false,
      bipolarDisorder: false,
      schizophrenia: false,
    },
    genitourinary: {
      kidneyStones: false,
      uti: false,
      incontinence: false,
      chronicKidneyDisease: false,
    },
    gastrointestinal: {
      gerd: false,
      crohnsDisease: false,
      ulcerativeColitis: false,
      irritableBowelSyndrome: false,
    },
    immuneSystem: {
      autoimmuneDisorders: false,
      lupus: false,
      rheumatoidArthritis: false,
    },
  });
  const [SurgicalHistoryform, setSurgicalHistoryform] = useState({
    cardiovascularSurgeries: {
      aneurysmRepair: false,
      cabg: false,
      carotidEndarterectomy: false,
      pacemakerDefibrillator: false,
      ptcaPci: false,
    },
    commonSurgeries: {
      appendectomy: false,
      backSurgery: false,
      bariatricSurgery: false,
      bilateralTubalLigation: false,
      breastResectionMastectomy: false,
      carpalTunnelRelease: false,
    },
    ophthalmologySurgeries: {
      cataractLensSurgery: false,
      lasik: false,
    },
    gynecologicalSurgeries: {
      cesareanSection: false,
      dilationAndCurettage: false,
      hysterectomy: false,
      tahBso: false,
    },
    urologicalSurgeries: {
      prostateSurgery: false,
      prostatectomy: false,
      turp: false,
      vasectomy: false,
    },
    orthopedicSurgeries: {
      hipArthroplasty: false,
      hipReplacement: false,
      kneeArthroplasty: false,
      rotatorCuffSurgery: false,
      spinalFusion: false,
    },
    entSurgeries: {
      sinusSurgery: false,
      tonsillectomyAdenoidectomy: false,
      nasalSurgery: false,
    },
    skinCancerSurgeries: {
      skinCancerExcision: false,
      hemorrhoidSurgery: false,
    },
    miscellaneousSurgeries: {
      cholecystectomy: false,
      laminectomy: false,
      spinalFusion: false,
    },
  });
  const handleMedicalCheckboxChange = (category, key, value) => {
    setMedicalData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: value,
      },
    }));
  };
  const handlesurgicalCheckboxChange = (category, key, value) => {
    setSurgicalHistoryform((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: value,
      },
    }));
  };
  const handleCheckboxChange = (category, key, value) => {
    setFormData((prev) => {
      const updated = {
        ...prev,
        [category]: {
          ...prev[category],
          [key]: value,
        },
      };

      if (key.toLowerCase().includes("other") && !value) {
        updated[category][`${key}Text`] = "";
      }

      return updated;
    });
  };
  const handleCheckboxLifestyleDeterminantsChange = (category, key, value) => {
    setLifestyleDeterminants((prev) => {
      const updated = {
        ...prev,
        [category]: {
          ...prev[category],
          [key]: value,
        },
      };

      if (key.toLowerCase().includes("other") && !value) {
        updated[category][`${key}Text`] = "";
      }

      return updated;
    });
  };

  const handlePsychiatricHistoryCheckboxChange = (category, key, value) => {
    setPsychiatricHistoryData((prev) => {
      const updated = {
        ...prev,
        [category]: {
          ...prev[category],
          [key]: value,
        },
      };

      // Clear other text if unchecked
      if (key.toLowerCase().includes("other") && !value) {
        updated[category][`${key}Text`] = "";
      }

      return updated;
    });
  };
  const MedicalHistoryonSave = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    const dataparam = {
      agencyId,
      patientId,
      ...medicalData,
    };
    // console.log(data, "save===data===>>>");

    try {
      const response = await MedicalHistoryonsubmit(dataparam);
      // console.log(response?.data?.data, "hii-=--MedicalHistoryonsubmit----");
      ShowToast(response?.data?.message);
      GetMedicalHistory();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting medical history:", error);
    }
  };
  const MedicalHistoryUpdate = async () => {
    const data = {
      // id,
      ...medicalData,
    };
    // console.log(data, "submit datat======");
    try {
      const response = await MedicalHistoryonsubmitUpdate(
        medicalhistoryget?._id,
        data
      );
      // console.log(response?.data?.data, "update response======");
      ShowToast(response?.data?.message);
      GetMedicalHistory();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting MedicalHistoryUpdate:", error);
    }
  };
  const GetMedicalHistory = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    try {
      const response = await FetchMedicalHistory(agencyId, patientId);
      const data = response?.data?.data;
      // console.log(data, "get respo=======");
      if (data && Object.keys(data).length > 0) {
        setmedicalhistoryget(data);
        setMedicalData({
          head: data.head || {},
          eyes: data.eyes || {},
          ears: data.ears || {},
          noseSinuses: data.noseSinuses || {},
          mouthThroatTeeth: data.mouthThroatTeeth || {},
          cardiovascular: data.cardiovascular || {},
          respiratory: data.respiratory || {},
          neurological: data.neurological || {},
          musculoskeletal: data.musculoskeletal || {},
          skin: data.skin || {},
          endocrine: data.endocrine || {},
          infectiousDiseases: data.infectiousDiseases || {},
          hematologicOncologic: data.hematologicOncologic || {},
          psychiatric: data.psychiatric || {},
          genitourinary: data.genitourinary || {},
          gastrointestinal: data.gastrointestinal || {},
          immuneSystem: data.immuneSystem || {},
        });
      } else {
      }
    } catch (error) {
      console.log("Error fetching family history:", error);
    }
  };
  const SurgicalHistorySave = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    const dataparam = {
      agencyId,
      patientId,
      ...SurgicalHistoryform,
    };
    // return
    try {
      const response = await SurgicalHistoryonsubmit(dataparam);
      ShowToast(response?.data?.message);
      FetchSurgicalHistory();
      handleCloseModal();
    } catch (error) {
      console.log(error);
    }
  };
  const FetchSurgicalHistory = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    // return
    try {
      const response = await GetSurgicalHistory(agencyId, patientId);
      const data = response?.data?.data;
      // console.log(data, "get respo=======");
      if (data && Object.keys(data).length > 0) {
        setSurgicalHistoryget(data);
        setSurgicalHistoryform({
          cardiovascularSurgeries: data.cardiovascularSurgeries || {},
          commonSurgeries: data.commonSurgeries || {},
          ophthalmologySurgeries: data.ophthalmologySurgeries || {},
          gynecologicalSurgeries: data.gynecologicalSurgeries || {},
          urologicalSurgeries: data.urologicalSurgeries || {},
          orthopedicSurgeries: data.orthopedicSurgeries || {},
          entSurgeries: data.entSurgeries || {},
          skinCancerSurgeries: data.skinCancerSurgeries || {},
          miscellaneousSurgeries: data.miscellaneousSurgeries || {},
        });
      } else {
        console.log("No family history data found or data is empty.");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const UpdateSurgicalHistory = async () => {
    const data = {
      // id,
      ...SurgicalHistoryform,
    };
    try {
      const response = await SurgicalHistoryonsubmitUpdate(
        SurgicalHistoryget?._id,
        data
      );
      // console.log(response?.data, "========>>>>");
      handleCloseModal();
      FetchSurgicalHistory();
    } catch (error) {
      console.log(error);
    }
  };
  const Getfamilyhistory = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    try {
      const response = await FetchFamilyHistory(agencyId, patientId);
      const data = response?.data?.data;

      if (data && Object.keys(data).length > 0) {
        setfamilyhistoryget(data);
        setFormData({
          generalHealthConditions: data.generalHealthConditions || {},
          cardiovascularAndOthers: data.cardiovascularAndOthers || {},
          cancer: data.cancer || {},
        });
      } else {
      }
    } catch (error) {
      console.log("Error fetching family history:", error);
    }
  };
  const FamilyHistorysave = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    const dataparam = {
      agencyId,
      patientId,
      ...formData,
    };
    try {
      const response = await FamilyHistoryonsubmit(dataparam);
      Getfamilyhistory();
      ShowToast(response?.data?.message);
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting family history:", error);
    }
  };
  const FamilyHistoryUpdate = async () => {
    const data = {
      ...formData,
    };
    try {
      const response = await FamilyHistoryonsubmitUpdate(
        familyhistoryget?._id,
        data
      );
      ShowToast(response?.data?.message);
      Getfamilyhistory();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting family history:", error);
    }
  };
  const PsychiatricHistorySave = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    const dataparam = {
      agencyId,
      patientId,
      ...psychiatricHistoryData,
    };
    // return
    try {
      const response = await PsychiatricHistoryonsubmit(dataparam);

      // ShowToast(response?.data?.message);
      Getpsychiatrichistory();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting PsychiatricHistoryonsubmit:", error);
    }
  };
  const Getpsychiatrichistory = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    try {
      const response = await FetchPsychiatricHistory(agencyId, patientId);
      const data = response?.data?.data;
      if (data && Object.keys(data).length > 0) {
        setpsychiatricdata(data);
        setPsychiatricHistoryData({
          psychiatricConditions: data.psychiatricConditions || {},
          neurocognitiveDisorders: data.neurocognitiveDisorders || {},
          developmentalDisorders: data.developmentalDisorders || {},
          symptoms: data.symptoms || {},
          mentalHealthTreatmentHistory: data.mentalHealthTreatmentHistory || {},
          substanceUse: data.substanceUse || {},
          familypaychiaticHistory: data.familypaychiaticHistory || {},
          socialEnvironmentalstressors: data.socialEnvironmentalstressors || {},
          cognitiveandBehavioralPatterns:
            data.cognitiveandBehavioralPatterns || {},
          sleepandEnergyLevels: data.sleepandEnergyLevels || {},
        });
      } else {
        // console.log("No family history data found or data is empty.");
      }
    } catch (error) {
      console.log("Error fetching family history:", error);
    }
  };
  const PsychiatricHistoryUpdate = async () => {
    const data = {
      ...psychiatricHistoryData,
    };
    try {
      const response = await PsychiatricHistoryonsubmitUpdate(
        psychiatricdata?._id,
        data
      );
      // console.log(response?.data?.data, "update response======");
      ShowToast(response?.data?.message);
      Getpsychiatrichistory();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting MedicalHistoryUpdate:", error);
    }
  };
  const LifestyleDeterminantsUpdate = async () => {
    const data = {
      ...LifestyleDeterminants,
    };
    try {
      const response = await LifestyleDeterminantsonsubmitUpdate(
        LifestyleDeterminantsget?._id,
        data
      );
      ShowToast(response?.data?.message);
      GetLifestyleDeterminants();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting MedicalHistoryUpdate:", error);
    }
  };
  const LifestyleDeterminantsSave = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    const dataparam = {
      agencyId,
      patientId,
      ...LifestyleDeterminants,
    };
    try {
      const response = await LifestyleDeterminantsnsubmit(dataparam);
      ShowToast(response?.data?.message);
      GetLifestyleDeterminants();
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting LifestyleDeterminantsnsubmit:", error);
    }
  };
  const GetLifestyleDeterminants = async () => {
    const agencyId = appointmentdetail?.agencyId;
    const patientId = data?.patientId;
    try {
      const response = await FetchLifestyleDeterminants(agencyId, patientId);
      const data = response?.data?.data;
      if (data && Object.keys(data).length > 0) {
        setLifestyleDeterminantsget(data);
        setLifestyleDeterminants({
          tobaccoUse: data.tobaccoUse || {},
          alcoholUse: data.alcoholUse || {},
          substanceUse: data.substanceUse || {},
          cardiovascularHealth: data.cardiovascularHealth || {},
          patternsHistorySubstanceUse: data.patternsHistorySubstanceUse || {},
          safetyPractices: data.safetyPractices || {},
          sexualActivity: data.sexualActivity || {},
          birthGender: data.birthGender || {},
        });
      } else {
        // console.log("No family history data found or data is empty.");
      }
    } catch (error) {
      console.log("Error fetching family history:", error);
    }
  };
  const handleOpenModal = (modalId) => {
    setOpenModal(modalId);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };
  useEffect(() => {
    Getfamilyhistory();
    GetMedicalHistory();
    Getpsychiatrichistory();
    GetLifestyleDeterminants();
    FetchSurgicalHistory();
  }, []);
       const handleSave = () => {
      onComplete?.(true);
  };
  return (
    <div className="basic-info-form">
      <h2>History Form</h2>
      <p className="form-description">
        Please complete the Basic Info form. All fields marked with * are
        required.
      </p>

      <>
        <h3>Medical History</h3>
        <p>Please select a subsection to complete:</p>
        <div className="history-subsections">
          <button
            className="cta-button"
            onClick={() => handleOpenModal("generalConditions")}
          >
            General Conditions
          </button>
          <button
            className="cta-button"
            onClick={() => handleOpenModal("surgicalHistory")}
          >
            Surgical History
          </button>
          <button
            className="cta-button"
            onClick={() => handleOpenModal("familyHistory")}
          >
            Family History
          </button>
          <button
            className="cta-button"
            onClick={() => handleOpenModal("psychHistory")}
          >
            Psychiatric History
          </button>
          <button
            className="cta-button"
            onClick={() => handleOpenModal("drugUseHistory")}
          >
            Lifestyle Determinants
          </button>

        </div>
         <button
              className="cta-button"
              id="completeForm"
              type="button"
              style={{ marginTop: 20, width: "100%",}}
              onClick={handleSave}
            >
              Save
            </button>
      </>

      <>
        {openModal === "generalConditions" && (
          <div
            aria-modal="true"
            className="modal_verify"
            id="generalConditionsModal"
            role="dialog"
          >
            <div className="modal-content_verify" style={{ maxWidth: 1000 }}>
              <button className="close_verify" onClick={handleCloseModal}>
                ×
              </button>
              <h3>General Conditions</h3>
              <hr />
              <div className="modal-body_history_two" id="modal-body">
                {Medicalhistoycategories.map(
                  ({ category, label, options }, index) => (
                    <div className="category_history" key={index}>
                      <h4>{label}</h4>
                      {Object.entries(options).map(([key, optionLabel], i) => (
                        <label key={i}>
                          <input
                            type="checkbox"
                            checked={medicalData[category][key]}
                            onChange={(e) =>
                              handleMedicalCheckboxChange(
                                category,
                                key,
                                e.target.checked
                              )
                            }
                          />{" "}
                          {optionLabel}
                        </label>
                      ))}
                    </div>
                  )
                )}
              </div>
              <hr />
              <div className="modal-footer_history">
                <button onClick={handleCloseModal}>Cancel</button>
                {!medicalhistoryget?._id ? (
                  <button onClick={MedicalHistoryonSave}>Save</button>
                ) : (
                  <button onClick={MedicalHistoryUpdate}>Update</button>
                )}
              </div>
            </div>
          </div>
        )}
        {/* 2) Surgical History Modal */}
        {openModal === "surgicalHistory" && (
          <div
            aria-modal="true"
            className="modal_verify"
            id="surgicalHistoryModal"
            role="dialog"
          >
            <div className="modal-content_verify" style={{ maxWidth: 1000 }}>
              <button className="close_verify" onClick={handleCloseModal}>
                ×
              </button>
              <h3>Surgical History</h3>
              <hr />
              <div className="modal-body_history" id="modal-body">
                {SurgicalHistorydata.map(
                  ({ category, label, options }, index) => (
                    <div className="category_history" key={index}>
                      <h4>{label}</h4>
                      {Object.entries(options).map(([key, optionLabel], i) => (
                        <label key={i}>
                          <input
                            type="checkbox"
                            checked={SurgicalHistoryform[category][key]}
                            onChange={(e) =>
                              handlesurgicalCheckboxChange(
                                category,
                                key,
                                e.target.checked
                              )
                            }
                          />{" "}
                          {optionLabel}
                        </label>
                      ))}
                    </div>
                  )
                )}
              </div>
              <hr />
              <div className="modal-footer_history">
                <button onClick={handleCloseModal}>Cancel</button>

                {!SurgicalHistoryget?._id ? (
                  <button onClick={SurgicalHistorySave}>Save</button>
                ) : (
                  <button onClick={UpdateSurgicalHistory}>Update</button>
                )}
              </div>
            </div>
          </div>
        )}
        {/* 3) Family History Modal */}
        {openModal === "familyHistory" && (
          <div
            aria-modal="true"
            className="modal_verify"
            id="familyHistoryModal"
            role="dialog"
          >
            <div className="modal-content_verify" style={{ maxWidth: 1000 }}>
              <button className="close_verify" onClick={handleCloseModal}>
                ×
              </button>
              <h3>Family History</h3>
              <hr />
              <div className="modal-body_history" id="modal-body">
                {FamilyHistorydata.map(
                  ({ category, label, options }, index) => (
                    <div className="category_history" key={index}>
                      <h4>{label}</h4>
                      {Object.entries(options).map(([key, optionLabel], i) => (
                        <div key={i} className="flex flex-col gap-1 mb-2">
                          <label className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={formData[category][key]}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  category,
                                  key,
                                  e.target.checked
                                )
                              }
                            />{" "}
                            {optionLabel}
                          </label>

                          {key.toLowerCase().includes("other") &&
                            formData[category][key] && (
                              <input
                                type="text"
                                placeholder="Please specify"
                                className="border p-1 rounded w-full max-w-xs"
                                value={formData[category][`${key}Text`] || ""}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    [category]: {
                                      ...prev[category],
                                      [`${key}Text`]: e.target.value,
                                    },
                                  }))
                                }
                              />
                            )}
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
              <hr />
              <div className="modal-footer_history">
                <button onClick={handleCloseModal}>Cancel</button>
                {!familyhistoryget?._id ? (
                  <button onClick={FamilyHistorysave}>Save</button>
                ) : (
                  <button onClick={FamilyHistoryUpdate}>Update</button>
                )}
              </div>
            </div>
          </div>
        )}
        {/* 4) Psychiatric History Modal */}
        {openModal === "psychHistory" && (
          <div
            aria-modal="true"
            className="modal_verify"
            id="psychHistoryModal"
            role="dialog"
          >
            <div className="modal-content_verify" style={{ maxWidth: 1000 }}>
              <button className="close_verify" onClick={handleCloseModal}>
                ×
              </button>
              <h3>Psychiatric History</h3>
              <hr />
              <div className="modal-body_history" id="modal-body">
                {PsychiatricHistorydata.map(
                  ({ category, label, options }, index) => (
                    <div className="category_history" key={index}>
                      <h4>{label}</h4>
                      {Object.entries(options).map(([key, optionLabel], i) => (
                        <div
                          key={i}
                          className="flex items-start gap-2 flex-col mb-2"
                        >
                          <label className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={psychiatricHistoryData[category][key]}
                              onChange={(e) =>
                                handlePsychiatricHistoryCheckboxChange(
                                  category,
                                  key,
                                  e.target.checked
                                )
                              }
                            />{" "}
                            {optionLabel}
                          </label>

                          {/* Show text field if 'Other' is checked */}
                          {key.toLowerCase().includes("other") &&
                            psychiatricHistoryData[category][key] && (
                              <input
                                type="text"
                                placeholder="Please specify"
                                className="border p-1 rounded w-full max-w-xs"
                                value={
                                  psychiatricHistoryData[category][
                                    `${key}Text`
                                  ] || ""
                                }
                                onChange={(e) =>
                                  setPsychiatricHistoryData((prev) => ({
                                    ...prev,
                                    [category]: {
                                      ...prev[category],
                                      [`${key}Text`]: e.target.value,
                                    },
                                  }))
                                }
                              />
                            )}
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
              <hr />
              <div className="modal-footer_history">
                <button onClick={handleCloseModal}>Cancel</button>
                {!psychiatricdata?._id ? (
                  <button onClick={PsychiatricHistorySave}>Save</button>
                ) : (
                  <button onClick={PsychiatricHistoryUpdate}>Update</button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Lifestyle Determinants Modal */}
        {openModal === "drugUseHistory" && (
          <div
            aria-modal="true"
            className="modal_verify"
            id="drugUseHistoryModal"
            role="dialog"
          >
            <div className="modal-content_verify" style={{ maxWidth: 1000 }}>
              <button className="close_verify" onClick={handleCloseModal}>
                ×
              </button>
              <h3>Lifestyle Determinants</h3>
              <hr />
              <div className="modal-body_history" id="modal-body">
                {LifestyleDeterminantsdata.map(
                  ({ category, label, options }, index) => (
                    <div className="category_history" key={index}>
                      <h4>{label}</h4>
                      {Object.entries(options).map(([key, optionLabel], i) => (
                        <div key={i} className="flex flex-col gap-1 mb-2">
                          <label className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={LifestyleDeterminants[category][key]}
                              onChange={(e) =>
                                handleCheckboxLifestyleDeterminantsChange(
                                  category,
                                  key,
                                  e.target.checked
                                )
                              }
                            />{" "}
                            {optionLabel}
                          </label>

                          {key.toLowerCase().includes("other") &&
                            LifestyleDeterminants[category][key] && (
                              <input
                                type="text"
                                placeholder="Please specify"
                                className="border p-1 rounded w-full max-w-xs"
                                value={
                                  LifestyleDeterminants[category][
                                    `${key}Text`
                                  ] || ""
                                }
                                onChange={(e) =>
                                  setLifestyleDeterminants((prev) => ({
                                    ...prev,
                                    [category]: {
                                      ...prev[category],
                                      [`${key}Text`]: e.target.value,
                                    },
                                  }))
                                }
                              />
                            )}
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
              <hr />
              <div className="modal-footer_history">
                <button onClick={handleCloseModal}>Cancel</button>

                {!LifestyleDeterminantsget?._id ? (
                  <button onClick={LifestyleDeterminantsSave}>Save</button>
                ) : (
                  <button onClick={LifestyleDeterminantsUpdate}>Update</button>
                )}
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default MedicalHistory;
